import PropTypes from 'prop-types'
import LinkButtonBox from '../ui/LinkButtonBox'

const TipoPublicacion = (props) => {
  return (
    <div className="row">
      <div className="col-6 d-none d-md-block">
        <div className="borde-normal-nota text-center mb-0">
          Elige Publicación Simple si quieres hacer una única publicación
        </div>
        <LinkButtonBox
          name="btnPublicacionSimple"
          onClick={() => props.onClick(false)}
          texto="Publicacion Simple"
          className="btn borde-normal-seleccion text-center mt-1"
          classNameIcono="fa fa-file-o fa-5x"
        />
      </div>
      <div className="col-6 d-none d-md-block">
        <div className="borde-normal-nota text-center mb-0">
          Elige Publicación Masiva si quieres hacer varias publicaciones
        </div>
        <LinkButtonBox
          name="btnPublicacionMasiva"
          onClick={() => props.onClick(true)}
          texto="Publicacion Masiva"
          className="btn borde-normal-seleccion text-center mt-1"
          classNameIcono="fa fa-files-o fa-5x"
        />
      </div>
    </div>
  )
}

TipoPublicacion.propTypes = {
  onClick: PropTypes.func.isRequired
}

export default TipoPublicacion
